import React from 'react'
import styled from 'styled-components'

interface EmbeddedVideoProps {
    videoPath: string
    height?: number | string
    width?: number | string
}
const getUrlParam = (videoPath: string) => {
    try {
        const url = new URL(videoPath)
        return new URLSearchParams(url.search).get('v') ?? ''
    } catch (_) {
        return ''
    }
}

const VideoFrame = styled.iframe`
    border-radius: 5px;
    margin-bottom: 15px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`

const EmbeddedVideo = ({ videoPath, height, width }: EmbeddedVideoProps) => (
    <VideoFrame
        width={width ?? '300'}
        height={height ?? '200'}
        src={`https://www.youtube.com/embed/${getUrlParam(videoPath)}`}
        title="Vorstellungs - YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
    >
        Video kann nicht wiedergegeben werden.
    </VideoFrame>
)

export default EmbeddedVideo
